import React from 'react';
import {Col, Label, Row} from 'reactstrap';
import {AvGroup} from 'availity-reactstrap-validation';
import {Button} from 'reactstrap';
import PropTypes from 'prop-types';
import AvField from "../../shared/component/form/AvField";
import Translate from "../../shared/language/Translate";
import {Fieldset} from "primereact/fieldset";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import ProductService from "../../shared/service/ProductService";
import {InputNumber} from "primereact/inputnumber";
import {STOCK_EVENT, STOCK_EVENT_ADD_REASON, STOCK_EVENT_DROP_REASON} from "../../shared/utils/Constants";


const defaultProduct = {
    id: '',
    name: '',
    status: 'ACTIVE',
    barcode: '',
    price: null,
    price2: null,
    price3: null,
    price4: ''

};
export default class ProductPriceSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            product: Object.assign({}, defaultProduct),
            productDetailsSaveButtonRender: true,
        }
        this.productService = new ProductService();
    }

    componentDidMount() {

    }

    clearData = () => {
        this.setState({
            product: Object.assign({}, defaultProduct),
        });

    }
    setData = (data) => {
        this.setState({
            product: Object.assign({}, data),
        });
    }


    render() {
        return (<div className="p-col-12">
            <Fieldset legend={"Update Price"}>
                <Row>
                    <Col md="4">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate contentKey="producttradingName">Barcode</Translate>
                            </Label>
                            <AvField
                                type="number"
                                className="form-control"
                                name="barcode"
                                disabled={true}
                                max="99999999999999"
                                value={this.state.product.barcode}
                                onChange={this.__handleChange}/>


                        </AvGroup>
                    </Col>

                    <Col md="4">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate contentKey="producttradingName">Name</Translate>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="name"
                                disabled={true}
                                value={this.state.product.name}
                                onChange={this.__handleChange}/>


                        </AvGroup>
                    </Col>

                    <Col md="4">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate contentKey="producttradingName">Till Price</Translate>
                                <span style={{color: 'red'}}> (*)</span>
                            </Label>

                            <InputNumber
                                name="price"
                                disabled={false}
                                value={this.state.product.price}
                                onChange={this.__handleChange}
                                mode="currency"
                                currency="GBP" locale="en-US"
                            />
                        </AvGroup>
                    </Col>

                    <Col md="4">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate contentKey="producttradingName">Price 2</Translate>
                            </Label>

                            <InputNumber
                                name="price2"
                                disabled={false}
                                value={this.state.product.price2}
                                onChange={this.__handleChange}
                                mode="currency"
                                currency="GBP" locale="en-US"
                            />
                        </AvGroup>
                    </Col>

                    <Col md="4">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate contentKey="producttradingName">Price 3</Translate>
                            </Label>

                            <InputNumber
                                name="price3"
                                disabled={false}
                                value={this.state.product.price3}
                                onChange={this.__handleChange}
                                mode="currency"
                                currency="GBP" locale="en-US"
                            />
                        </AvGroup>
                    </Col>


                    <Col md="4">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate contentKey="producttradingName">Price 4</Translate>
                            </Label>
                            <InputNumber
                                name="price4"
                                disabled={false}
                                value={this.state.product.price4}
                                onChange={this.__handleChange}
                                mode="currency"
                                currency="GBP" locale="en-US"
                            />

                        </AvGroup>
                    </Col>


                </Row>

                {!GeneralUtils.isNullOrEmpty(this.state.product.id) && GeneralUtils.checkPrivilege("post_product/product") &&
                    <Button color="outline-primary" style={{marginRight: '5px'}} onClick={() => {
                        this.updateProduct();
                    }}>
                        <Translate contentKey="entity.action.add">Save Price</Translate>
                    </Button>
                }


                <Button color="outline-primary" style={{marginRight: '5px'}} onClick={() => {
                    this.props.closeDisplayDialog();
                }}>
                    <Translate contentKey="entity.action.add">Close</Translate>
                </Button>
            </Fieldset>
        </div>)
            ;
    }

    updateProduct = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.product.id)) {
            this.productService.update(this.state.product)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            product: response,
                        });
                        this.props.refreshDataTable();
                    }
                });
        }

    }


    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let product = this.state.product;
        product[e.target.name] = value;
        this.setState({product: product});
    }


}

ProductPriceSave.propTypes = {
    order: PropTypes.object
};
